export { getFileIcon as getIcon } from '@nora-monorepo/ui-shared';

export function getExtension(mimeType: string): string | null {
  const mimeToExtension: { [key: string]: string } = {
    'text/html': 'html',
    'text/plain': 'txt',
    'text/css': 'css',
    'text/javascript': 'js',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/svg+xml': 'svg',
    'audio/mpeg': 'mp3',
    'audio/wav': 'wav',
    'video/mp4': 'mp4',
    'video/quicktime': 'mov',
    'video/webm': 'webm',
    'application/pdf': 'pdf',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      'docx',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      'pptx',
    'application/json': 'json',
    'application/xml': 'xml',
    'application/zip': 'zip',
  };

  return mimeToExtension[mimeType] || '';
}
